import React from 'react';

export default function HomePageHeaderImage() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7203_427563)">
        <path
          d="M2 100C7.11 100 13.88 97.33 17.19 91.67C17.3952 91.3492 17.5789 91.0151 17.74 90.67C18.5392 88.8847 18.9678 86.9558 19 85H58L58.0007 99.1871C75.509 92.9591 77 68 77 68H87V59H93L93.18 69.15C93.1128 74.3749 94.4975 79.5158 97.18 84C97.26 84.13 97.33 84.26 97.41 84.38C97.49 84.5 97.67 84.8 97.81 85L98.1 85.42C105.54 96.25 118.67 100 118.67 100H2Z"
          fill="#C2E2FF"
        />
        <path
          d="M61.58 94.3C64.4839 94.2383 66.9604 96.2531 67.5661 99.0001L120 99V100H0V99L3.06356 98.9996C9.12495 95.7635 15.0368 95.7635 17.331 98.9996L54.6204 99.0007C55.8063 96.2371 58.5098 94.3711 61.58 94.3ZM25 90V91H17.59L18.04 90H25ZM89 89V90H81V89H89ZM97.22 84C97.3 84.13 97.37 84.26 97.45 84.38C97.53 84.5 97.71 84.8 97.85 85H86V84H97.22Z"
          fill="#192C55"
        />
        <path
          d="M43.2001 60.04C45.6688 60.04 47.6701 62.0413 47.6701 64.51V81.15H47.7101C50.3074 81.15 52.4146 79.0474 52.4201 76.45V66.8C52.2545 65.6382 52.7817 64.4865 53.7692 63.8524C54.7568 63.2183 56.0234 63.2183 57.0109 63.8524C57.9985 64.4865 58.5256 65.6382 58.3601 66.8V76.45C58.3574 79.2825 57.2277 81.9974 55.2202 83.9955C53.215 85.9913 50.4989 87.108 47.6701 87.1001L47.6701 100H38.7301V87.1L38.2301 87.1001C32.3528 87.089 27.5911 82.3273 27.5801 76.45V73.34C27.5801 71.6832 28.9232 70.34 30.5801 70.34C32.2369 70.34 33.5801 71.6832 33.5801 73.34V76.45C33.5856 79.0435 35.6866 81.1445 38.2801 81.15H38.7301V64.51C38.7301 62.0413 40.7314 60.04 43.2001 60.04Z"
          fill="#116DFF"
        />
        <path
          d="M23.4001 57.37C28.3928 57.37 32.4401 53.3227 32.4401 48.33C32.4401 43.3374 28.3928 39.29 23.4001 39.29C18.4075 39.29 14.3601 43.3374 14.3601 48.33C14.3601 53.3227 18.4075 57.37 23.4001 57.37Z"
          fill="#FFD527"
        />
      </g>
      <defs>
        <clipPath id="clip0_7203_427563">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
